import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import StandardModal from 'shared/StandardModal.jsx';
import StandardField from 'shared/StandardField.jsx';

const required = value => value ? undefined : 'Required';
const pattern =/^-?\d+\.?\d*$/;
const numberOnly = value => pattern.test(value) ? undefined : 'Only Numeric values allowed';
const uniqueFee = value => value == defaultTechFee ? 'Technology Fee cannot be the same as the Default Fee' : undefined;
let defaultTechFee = 0;

const TournamentTechFeeModal = ({
  visible,
  defaultTechnologyFee,
  onCancel,
  handleSubmit,
  onSubmit
}) =>{
  defaultTechFee = defaultTechnologyFee;
  return (<StandardModal
    title="Tournament Technology Fee"
    visible={visible}
    onCloseClick={onCancel}>
      <div>
        <form id="tournamentTechFeeForm"
          onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <Field
              name="fee"
              type="text"
              component={StandardField}
              label="Technology Fee"
              placeholder="Enter tournament tech fee..."
              validate={[ required ], [numberOnly], [uniqueFee]}
            />
          </div>
          <div className="form-group text-right">
              <button
                type="button"
                className="btn btn-link"
                onClick={() => onCancel()}
              >{'Cancel'}</button>
              {` `}
              <button
                type="submit"
                className="btn btn-primary btn-lg"
              >{'Save'}</button>
          </div>
          <input type="hidden" 
          name="tournamentId"/>
        </form>
      </div>
    </StandardModal>
  );
};

TournamentTechFeeModal.propTypes = {
  visible: PropTypes.bool,
  defaultTechnologyFee: PropTypes.number,
  onCancel: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func
};

export default reduxForm({
  form: 'tournamentTechFeeForm'
})(TournamentTechFeeModal);



// WEBPACK FOOTER //
// ./src/features/finance/fees/TournamentTechFeeModal.jsx